/* eslint-disable jsx-a11y/no-static-element-interactions */
import classNames from 'classnames';
import React, { useContext } from 'react';

import { RicosNodeContext } from './../../ricos-context';
import type { NodeViewRendererProps } from './../../ricos-types';

import collapsibleListItemStyles from '../statics/styles/collapsible-list-pair.rtlignore-scss';
import { getAlignmentFromDirection } from '../utils';

const CollapsibleListItemProperty = ({
  node,
  RicosNodesRenderer,
  type,
}: NodeViewRendererProps & { type: 'title' | 'body' }) => {
  const { parentNode } = useContext(RicosNodeContext);
  const parentNodeDirection = parentNode?.collapsibleListData?.direction;
  const listAlignment = parentNodeDirection
    ? getAlignmentFromDirection(parentNodeDirection)
    : undefined;

  return (
    <div
      className={classNames(
        collapsibleListItemStyles.container,
        collapsibleListItemStyles.viewerContainer,
        type === 'title' ? collapsibleListItemStyles.titleContainer : null,
        collapsibleListItemStyles.innerEditor
      )}
    >
      <div
        style={{
          width: '100%',
          textAlign: listAlignment,
        }}
      >
        <RicosNodesRenderer nodes={node.nodes ?? []} shouldParagraphApplyTextStyle />
      </div>
    </div>
  );
};

export const CollapsibleListItemTitleProperty = ({ node, ...props }: NodeViewRendererProps) => {
  return <CollapsibleListItemProperty key={node.id} node={node} {...props} type="title" />;
};

export const CollapsibleListItemBodyProperty = ({ node, ...props }: NodeViewRendererProps) => {
  return <CollapsibleListItemProperty key={node.id} node={node} {...props} type="body" />;
};

export default CollapsibleListItemProperty;
